import Drawer, { Props as DrawerProps } from '../../../../../components/Drawer';
import TileDrawerStepper from '../../../../shared/TileDrawerStepper';
import DrawerHeader from '../DrawerHeader';
import PieChartSteps, { Steps } from '../PieChartSteps';

export interface PieChartDrawerProps extends Pick<DrawerProps, 'open' | 'onClose'> {}

export const PieChartDrawer = ({ open, onClose }: PieChartDrawerProps) => {
  return (
    <Drawer open={open} onClose={onClose} anchor="right">
      <TileDrawerStepper header={<DrawerHeader />} steps={Steps}>
        {({ currentStep, goToNextStep }) => <PieChartSteps currentStep={currentStep} goToNextStep={goToNextStep} />}
      </TileDrawerStepper>
    </Drawer>
  );
};

export default PieChartDrawer;
